import classes from './Header.module.css'

const Header = () =>{
    return(
        <h2 className={classes.heading}>ToDo List App</h2>
    )
}

export default Header